module.exports = __webpack_public_path__ + "img/icon_nav4.f5e5f9b2.png";